export default "__VITE_ASSET__CjkLKrxp__"